import { inject, Injectable } from '@angular/core';
import { filter, Observable, skipWhile, takeWhile } from 'rxjs';

import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

import { AppleApplicationStoreActions, AppleApplicationStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { isNotNullOrUndefined } from '@rocksoft/shared';

@Injectable({
  providedIn: 'root',
})
export class AppleApplicationsService {
  private readonly store = inject(Store);

  get applications(): Observable<AppleApplication[]> {
    return this.store.select(AppleApplicationStoreSelectors.selectAllAppleApplications);
  }

  getApplication(bundleIdentifier: string) {
    return this.store.select(AppleApplicationStoreSelectors.selectAppleApplicationsByBundleId(bundleIdentifier));
  }

  deleteApplication(bundleIdentifier: string, version: string) {
    this.store.dispatch(
      AppleApplicationStoreActions.AppleApplicationViewActions.applicationDeleted({
        bundleIdentifier,
        version: version,
      })
    );
  }

  postApplication(app: File): Observable<number> {
    this.store.dispatch(
      AppleApplicationStoreActions.AppleApplicationViewActions.applicationAdded({ application: app })
    );
    return this.store.select(AppleApplicationStoreSelectors.selectAppleApplicationUploadProgress).pipe(
      skipWhile((progress) => progress === null),
      takeWhile((progress) => progress !== null, true),
      filter(isNotNullOrUndefined)
    );
  }
}
